<template>
  <header class="header">
    <div class="header__heading">
      <slot name="page-heading"></slot>
    </div>

    <div class="header__tray">
      <slot name="page-filter"></slot>

      <div
        class="header__account"
        :class="{ 'header__account--open': isOpenAccount }"
      >
        <a
          href="javascript:;"
          class="header__account__avatar"
          :style="avatarStyle"
          :title="platformName"
          @click.prevent="toggleAccountMenu"
          v-click-outside="closeAccountMenu"
        >
          <template v-if="!platformColorPrimary">
            {{ platformShort }}
          </template>
        </a>

        <div class="header__account__menu">
          <ul>
            <li>
              <RouterLink to="/platform">
                Selecionar plataforma
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/my-account">
                Minha conta
              </RouterLink>
            </li>
            <li>
              <a
                href="javascript:;"
                @click.prevent="logout"
              >
                <strong>Sair</strong>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <KeepAlive>
      <CommonPageFilterBar
        v-if="showPageFilterBar"
        class="header__page-filter-bar"
      />
    </KeepAlive>
  </header>
</template>

<script>
import CommonPageFilterBar from '@/components/common/CommonPageFilterBar'
import ClickOutside from 'vue-click-outside'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'LayoutInsightsHeader',

  components: {
    CommonPageFilterBar
  },

  directives: {
    ClickOutside
  },

  data () {
    return {
      isOpenAccount: false
    }
  },

  computed: {
    ...mapState('base', ['showPageFilterBar']),

    ...mapGetters('auth', [
      'platformName',
      'platformSlug',
      'platformColorPrimary'
    ]),

    platformShort () {
      return this.platformName[0]
    },

    avatarStyle () {
      const { VUE_APP_PLATFORM_LOGOS_SOURCE: source } = process.env
      let style = ''

      if (this.platformColorPrimary) {
        style += `background-color: ${this.platformColorPrimary};`
        style += `background-image: url('${source}/${this.platformSlug}.png');`
      }

      return style
    }
  },

  methods: {
    toggleAccountMenu () {
      this.isOpenAccount = !this.isOpenAccount
    },

    closeAccountMenu () {
      this.isOpenAccount = false
    },

    logout () {
      this.$cookies.remove('tokenValidity')

      this.$auth.logout()
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  $header-height: map-get($layout-insights, 'header-height');
  $gap-bigger: map-get($layout-insights, 'gap-bigger');

  display: grid;
  grid-template: {
    columns: 1fr auto;
    rows: $header-height auto;
    areas:
      'heading tray'
      'page-filter-bar page-filter-bar';
  }
  padding: 0 $gap-bigger;

  &__heading {
    grid-area: heading;
    align-self: center;

    .heading {
      &--medium {
        margin-top: 3px;
      }
    }
  }

  &__tray {
    grid-area: tray;
    display: flex;
    align-items: center;
    gap: $gap-bigger;
  }

  &__page-filter-bar {
    grid-area: page-filter-bar;
  }

  &__account {
    $avatar-size: 50px;

    position: relative;

    &--open & {
      &__avatar {
        transform: scale(1.1);
      }

      &__menu {
        display: block;
      }
    }

    &__avatar {
      display: flex;
      width: $avatar-size;
      height: $avatar-size;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      transition: transform 0.2s !important;
      background: {
        color: map-get($colors-util, 'lighter');
        position: 50% 50%;
        repeat: no-repeat;
        size: 85%;
      }
      color: map-get($colors-util, 'light');
      font: {
        weight: 800;
        size: 21px;
      }

      &:hover {
        transform: scale(1.1);
      }
    }

    &__menu {
      z-index: 90;
      position: absolute;
      top: calc(100% + 10px);
      right: $avatar-size / 2;
      display: none;
      min-width: 200px;
      padding: 20px;
      border: 2px solid nth($colors-custom, 3);
      border-radius: 15px 0 15px 15px;
      box-shadow: 0 0 15px 10px rgba(23, 37, 66, 0.03);
      transition: all 0.2s;
      background: #fff;

      ul {
        padding: 0;

        li {
          display: block;
          margin: 5px 0;

          a {
            display: block;
            color: nth($colors-custom, 1);
            font: {
              weight: 400;
              size: 13px;
            }
            white-space: nowrap;
            line-height: 1.5;

            &:hover {
              color: nth($colors-custom, 2);
            }
          }

          strong {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
